import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, NgZone } from '@angular/core';
import { WINDOW } from '@lib/browser/window-providers';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Injectable()
export class ScrollService {
  private _event$: Observable<any>;

  public windowHeightLeftToScroll$: Observable<{
    screensToTop: number;
    screensToBottom: number;
  }>;

  constructor(
    private ngZone: NgZone,
    @Inject(WINDOW) private windowRef: Window,
    @Inject(DOCUMENT) private documentRef: Document,
  ) {
    this.ngZone.runOutsideAngular(() => {
      this._event$ = fromEvent(this.windowRef, 'scroll').pipe(debounceTime(100));
      this.windowHeightLeftToScroll$ = this.event$.pipe(
        map(this.windowHeightLeftToScroll),
      );
    });
  }

  public get event$() {
    return this._event$;
  }

  public get pixelsScrolled$() {
    if (this.event$) {
      return this.event$.pipe(
        map(() => this.documentRef.documentElement.scrollTop),
      );
    }

    return null;
  }

  public get percentScrolled$() {
    if (this.event$) {
      return this.event$.pipe(
        map(() => (
          this.documentRef.documentElement.scrollTop / this.windowRef.innerHeight
        )),
      );
    }

    return undefined;
  }

  public windowHeightLeftToScroll = () => {
    const { windowRef } = this;
    const { documentRef } = this;

    const scrollTop = documentRef.body.scrollTop || documentRef.documentElement.scrollTop;
    const scrollHeight = documentRef.body.scrollHeight || documentRef.documentElement.scrollHeight;
    const viewportHeight = windowRef.innerHeight;
    const scrolledDistance = scrollHeight - scrollTop;

    return {
      screensToTop: scrollTop / viewportHeight,
      screensToBottom: (scrolledDistance - viewportHeight) / viewportHeight,
    };
  };
}
